import {SortableContainer, SortableElement} from "react-sortable-hoc";
import React from "react";

export const DRAG_CLASS = 'drag';
const SortableItem = SortableElement(({value}) => value);
const SortableList = SortableContainer(({items}) => {
    return (
        <div>
            {items.map((item, index) => (
                <SortableItem
                    key={index}
                    index={index}
                    value={item}
                />
            ))}
        </div>
    );
});

export default function SortableListContainer({onSortEnd, items, disable, dragClass}) {
    function shouldCancelStart(e) {
        if (disable) {
            return true;
        }
        let relevantClass;
        if (e.target.className) {
            relevantClass = e.target.className;
            if (relevantClass && relevantClass.baseVal !== undefined) {
                relevantClass = relevantClass.baseVal;
            }
        }
        if (!relevantClass) {
            relevantClass = e.target.parentElement.className;
            if (relevantClass && relevantClass.baseVal !== undefined) {
                relevantClass = relevantClass.baseVal;
            }
        }

        return !relevantClass || !relevantClass.includes(dragClass);
    }

    return (
        <SortableList
            items={items}
            onSortEnd={onSortEnd}
            shouldCancelStart={shouldCancelStart}
        />
    )
}